import type { FacultyApproverDto } from './models';
import { RestService, Rest } from '@abp/ng.core';
import type { ListResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FacultyApproverService {
  apiName = 'Default';
  

  getCurrentUserPendingApprovalCount = (cancellationToken?: any, config?: Partial<Rest.Config>) =>
    this.restService.request<any, number>({
      method: 'GET',
      url: '/api/app/faculty-approver/current-user-pending-approval-count',
    },
    { apiName: this.apiName,...config });
  

  getList = (cancellationToken?: any, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ListResultDto<FacultyApproverDto>>({
      method: 'GET',
      url: '/api/app/faculty-approver',
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
